var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { ControlType } from '../api';
import { renderDynamicComponent } from '../render';
import Grid from '@material-ui/core/Grid';
var Stack = /** @class */ (function (_super) {
    __extends(Stack, _super);
    function Stack() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Stack.prototype.render = function () {
        var _this = this;
        if (this.props.control.kind == ControlType.Row) {
            return React.createElement(Grid, { container: true, spacing: 4 }, this.props.control.children
                .map(function (child, index) { return renderDynamicComponent(index, child, _this.props.dataState); }));
        }
        else {
            return React.createElement(Grid, { item: true, md: this.props.control.size }, this.props.control.children
                .map(function (child, index) { return renderDynamicComponent(index, child, _this.props.dataState); }));
        }
    };
    return Stack;
}(React.Component));
export default Stack;
//# sourceMappingURL=Stack.js.map